import { Shade } from './BodyItem';

export class Accessory {
  public type?: string;
  public name?: string;
  public shades?: Shade[];
  public open?: boolean;
  public className?: string;
  public visibility?: string;
  public id?: string;
}
